import { Component, OnInit } from '@angular/core';
import { ContadorService } from '../../../../providers/contador.service';
import { Contador } from '../../../../interfaces/contador';
import { Globals } from '../../../../globals';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { GeneralService } from '../../../../providers/general.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {
  cargando: boolean = true;
  contadores: Contador[] = <Contador[]>[];

  constructor(
    private contadorService: ContadorService,
    public globals: Globals,
    private _sanitizer: DomSanitizer,
    public general: GeneralService
  ) { }

  ngOnInit() {
    this.traerContadores();
  }

  traerContadores(): void {
    this.cargando = true;
    this.contadorService.getContadores(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        this.contadores = <Contador[]>[];
        if (respuesta.estado == 1 && respuesta.data) {
          respuesta.data.contadores.forEach(contador => {
            this.contadores.push(new Contador(
              contador.id,
              contador.porcentaje,
              contador.valor,
              contador.descripcion
            ));
          });
        }
      },
      () => {
        this.cargando = false;
      },
      () => {
        this.cargando = false;
      }
    );
  }

  getContadoresBackgrund(): SafeStyle {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${this.globals.webadmin}assets/web/index/${this.globals.empresa}/contadores_background.${this.globals.web_index_contadores_background_extension})`);
  }
}
